(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mi-plan-cuestionario"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.abbq-root').forEach(initQuiz);

  function initQuiz(root) {
    if (root.dataset.abbqInit) return;
    root.dataset.abbqInit = '1';

    var WHATSAPP = root.dataset.whatsapp || '15613023786';
    var BOOKING = root.dataset.booking || 'https://book.squareup.com/appointments/r64bl2e4et0n9b/location/LF6HMZZJT0F78/services/EPU6M5PKBPE4EJURJ4FZ25WS';
    var ENDPOINT = root.dataset.endpoint || '';
    var CHECKOUT_URL = root.dataset.checkout || 'https://agave-stripe.vercel.app/api/create-checkout';

    var zonesData = [
      { id: 'underarms', es: 'Axilas', en: 'Underarms', price: 49 },
      { id: 'lip', es: 'Bozo', en: 'Upper lip', price: 39 },
      { id: 'face', es: 'Cara completa', en: 'Full face', price: 85 },
      { id: 'bikini', es: 'Bikini / Brazilian', en: 'Bikini / Brazilian', price: 85 },
      { id: 'halflegs', es: '1/2 piernas', en: 'Half legs', price: 75 },
      { id: 'fulllegs', es: 'Piernas', en: 'Full legs', price: 99 },
      { id: 'arms', es: 'Brazos', en: 'Arms', price: 99 },
      { id: 'abdomen', es: 'Abdomen', en: 'Abdomen', price: 49 },
      { id: 'buttocks', es: 'Glúteos', en: 'Buttocks', price: 75 },
      { id: 'back', es: 'Espalda', en: 'Back', price: 99 },
      { id: 'chest', es: 'Pecho', en: 'Chest', price: 95 }
    ];

    var MIN_ZONES = 1;
    var lang = 'es';
    var history = [];
    var answers = { zones: new Set() };
    var stage = 'name';
    var horizonYears = 25;

    var navName = root.querySelector('[data-nav-name]');
    var annotCount = root.querySelector('[data-annot-count]');
    var progressFill = root.querySelector('[data-progress-fill]');
    var transcriptEl = root.querySelector('[data-transcript]');
    transcriptEl.className = 'abbq-transcript';
    var promptZone = root.querySelector('[data-prompt-zone]');

    function t(es, en) { return lang === 'es' ? es : en; }
    function fmt(n) { return Math.round(n).toLocaleString('en-US'); }
    function push(who, es, en) { history.push({ who: who, es: es, en: en }); }

    function calcProgress() {
      var order = ['name','zones','skinTone','hairColor','hairThickness','shaveFreq','hormonal','urgency','phone','email','done'];
      var idx = order.indexOf(stage);
      return Math.min(100, (idx / (order.length - 1)) * 100);
    }

    function renderTranscript() {
      transcriptEl.innerHTML = '';
      history.forEach(function (m) {
        var div = document.createElement('div');
        div.className = 'abbq-bubble ' + (m.who === 'guide' ? 'abbq-bubble-guide' : 'abbq-bubble-user');
        div.textContent = t(m.es, m.en);
        transcriptEl.appendChild(div);
      });
      progressFill.style.width = calcProgress() + '%';
      annotCount.textContent = history.filter(function (m) { return m.who === 'user'; }).length;
    }

    function scrollToBottom() {
      // Anchor the newest question near the top of the viewport so it's the
      // first thing read, with its options right below.
      requestAnimationFrame(function () {
        if (!promptZone || !transcriptEl) return;
        var bubbles = Array.prototype.slice.call(transcriptEl.querySelectorAll('.abbq-bubble'));
        if (!bubbles.length) return;

        var i = bubbles.length - 1;
        while (i > 0 && bubbles[i].classList.contains('abbq-bubble-guide') && bubbles[i - 1].classList.contains('abbq-bubble-guide')) i--;
        var anchor = bubbles[i].classList.contains('abbq-bubble-guide') ? bubbles[i] : promptZone;

        var pad = 96;
        var docMax = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        var target = anchor.getBoundingClientRect().top + window.pageYOffset - pad;
        var zoneBottom = promptZone.getBoundingClientRect().bottom + window.pageYOffset;
        target = Math.min(target, Math.max(0, zoneBottom - window.innerHeight + 24));
        target = Math.max(0, Math.min(target, docMax));

        if (Math.abs(target - window.pageYOffset) < 24) return;
        var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: target, behavior: smooth ? 'smooth' : 'auto' });
      });
    }

    function makeChip(labelEs, labelEn, priceLabel) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'abbq-chip';
      var span = document.createElement('span');
      span.textContent = t(labelEs, labelEn);
      btn.appendChild(span);
      if (priceLabel) {
        var p = document.createElement('span');
        p.className = 'abbq-price';
        p.textContent = priceLabel;
        btn.appendChild(p);
      }
      return btn;
    }

    function textStep(type, placeholderEs, placeholderEn, btnEs, btnEn, onSubmit) {
      var wrap = document.createElement('div');
      wrap.className = 'abbq-text-prompt';
      var input = document.createElement('input');
      input.className = 'abbq-input';
      if (type) input.type = type;
      input.placeholder = t(placeholderEs, placeholderEn);
      var btn = document.createElement('button');
      btn.className = 'abbq-btn abbq-btn-primary';
      btn.textContent = t(btnEs, btnEn);
      btn.addEventListener('click', function () { onSubmit(input.value.trim(), input); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') btn.click(); });
      wrap.appendChild(input); wrap.appendChild(btn);
      promptZone.appendChild(wrap);
    }

    function optionStep(options, field, onPick, singleCol) {
      var grid = document.createElement('div');
      grid.className = 'abbq-chip-grid' + (singleCol === false ? '' : ' abbq-single-col');
      options.forEach(function (o) {
        var chip = makeChip(o.es, o.en, o.priceLabel);
        chip.addEventListener('click', function () { onPick(o); });
        grid.appendChild(chip);
      });
      promptZone.appendChild(grid);
    }

    function renderPrompt() {
      promptZone.innerHTML = '';

      if (stage === 'name') {
        textStep('text', 'Tu nombre', 'Your name', 'Continuar', 'Continue', function (val) {
          if (!val) return;
          answers.name = val;
          navName.textContent = val;
          push('user', val, val);
          push('guide',
            'Mucho gusto, ' + val + '. Esta lectura es solo tuya — la voy guardando a tu nombre.',
            'Nice to meet you, ' + val + '. This reading is just for you — I\'m saving it under your name.');
          push('guide',
            'Dime, ' + val + ' — ¿dónde te gustaría dejar de pelear con el vello? Toca las zonas que quieras.',
            'Tell me, ' + val + ' — where would you like to stop fighting hair? Tap the zones you want.');
          stage = 'zones';
          renderTranscript(); renderPrompt(); scrollToBottom();
        });
        return;
      }

      if (stage === 'zones') {
        var grid = document.createElement('div');
        grid.className = 'abbq-chip-grid';
        zonesData.forEach(function (z) {
          var chip = makeChip(z.es, z.en, '$' + z.price + t('/mes', '/mo'));
          chip.setAttribute('aria-pressed', answers.zones.has(z.id) ? 'true' : 'false');
          chip.addEventListener('click', function () {
            if (answers.zones.has(z.id)) answers.zones.delete(z.id); else answers.zones.add(z.id);
            renderPrompt();
          });
          grid.appendChild(chip);
        });
        promptZone.appendChild(grid);

        var actions = document.createElement('div');
        actions.className = 'abbq-prompt-actions';
        var next = document.createElement('button');
        next.className = 'abbq-btn abbq-btn-primary';
        next.textContent = t('Listo →', 'Done →');
        next.disabled = answers.zones.size < MIN_ZONES;
        next.style.opacity = next.disabled ? '0.45' : '1';
        next.addEventListener('click', function () {
          var names = zonesData.filter(function (z) { return answers.zones.has(z.id); }).map(function (z) { return t(z.es, z.en); });
          push('user', names.join(', '), names.join(', '));
          var hasBrazilian = answers.zones.has('bikini');
          push('guide',
            hasBrazilian
              ? answers.name + ', brazilian — la zona donde la cuchilla más castiga: bolitas, encarnados, sombra justo donde más se nota. Es la que más piden.'
              : answers.name + ', buena selección — son zonas donde la cuchilla deja más marca: sombra, encarnados, piel irritada.',
            hasBrazilian
              ? answers.name + ', brazilian — the area where the razor punishes most: bumps, ingrowns, shadow right where it shows. It\'s the most requested.'
              : answers.name + ', good picks — these are areas where the razor leaves the most: shadow, ingrowns, irritated skin.');
          push('guide',
            'Ahora la piel: de eso depende qué tan seguro y rápido va el láser en ti.',
            'Now, your skin: that\'s what decides how safe and fast the laser goes for you.');
          stage = 'skinTone';
          renderTranscript(); renderPrompt(); scrollToBottom();
        });
        actions.appendChild(next);
        promptZone.appendChild(actions);
        return;
      }

      if (stage === 'skinTone') {
        optionStep([
          { v: 'clara', es: 'Clara · fototipo I–II', en: 'Fair · phototype I–II' },
          { v: 'media', es: 'Media / trigueña · fototipo III', en: 'Medium / olive · phototype III' },
          { v: 'morena', es: 'Morena · fototipo IV', en: 'Brown · phototype IV' },
          { v: 'oscura', es: 'Oscura · fototipo V–VI', en: 'Deep · phototype V–VI' }
        ], 'skinTone', function (o) {
          answers.skinTone = o.v;
          push('user', 'Mi tono: ' + t(o.es, o.en), 'My tone: ' + t(o.es, o.en));
          var isDeep = o.v === 'morena' || o.v === 'oscura';
          push('guide',
            isDeep
              ? answers.name + ', a este tono casi todas las clínicas te queman — el Alma Soprano ICE Platinum está calibrado justo para tu piel.'
              : answers.name + ', con tu tono el láser rinde rápido y sin drama.',
            isDeep
              ? answers.name + ', at this tone most clinics burn you — the Alma Soprano ICE Platinum is calibrated exactly for your skin.'
              : answers.name + ', with your tone the laser works fast and without drama.');
          stage = 'hairColor';
          push('guide', '¿De qué color es tu vello?', 'What color is your hair?');
          renderTranscript(); renderPrompt(); scrollToBottom();
        });
        return;
      }

      if (stage === 'hairColor') {
        optionStep([
          { v: 'negro', es: 'Vello negro', en: 'Black hair' },
          { v: 'castano', es: 'Vello castaño', en: 'Brown hair' },
          { v: 'rubio', es: 'Vello rubio', en: 'Blonde hair' },
          { v: 'canoso', es: 'Vello canoso o blanco', en: 'Gray or white hair' }
        ], 'hairColor', function (o) {
          answers.hairColor = o.v;
          push('user', o.es, o.en);
          var dark = o.v === 'negro' || o.v === 'castano';
          push('guide',
            dark
              ? answers.name + ', vello oscuro — el láser lo agarra rapidísimo. Es el mejor punto de partida que hay.'
              : answers.name + ', honestamente el láser rinde menos ahí — busca pigmento, y tu vello tiene poco. Te lo confirmamos sin adivinar en tu evaluación.',
            dark
              ? answers.name + ', dark hair — the laser grabs it fast. It\'s the best starting point there is.'
              : answers.name + ', honestly the laser works less there — it targets pigment, and your hair has little. We\'ll confirm at your evaluation.');
          stage = 'hairThickness';
          push('guide', '¿Qué tan grueso es tu vello?', 'How thick is your hair?');
          renderTranscript(); renderPrompt(); scrollToBottom();
        });
        return;
      }

      if (stage === 'hairThickness') {
        optionStep([
          { v: 'fino', es: 'Fino', en: 'Fine' },
          { v: 'medio', es: 'Medio', en: 'Medium' },
          { v: 'grueso', es: 'Grueso', en: 'Coarse' }
        ], 'hairThickness', function (o) {
          answers.hairThickness = o.v;
          push('user', 'Vello ' + o.es.toLowerCase(), o.en + ' hair');
          push('guide',
            o.v === 'grueso'
              ? answers.name + ', tu vello denso es el caso ideal. El láser apunta a la melanina del pelo: mientras más grueso, más la absorbe.'
              : answers.name + ', anotado — con eso ajustamos tu número de sesiones típico.',
            o.v === 'grueso'
              ? answers.name + ', your dense hair is the ideal case. Laser targets the hair\'s melanin: the thicker it is, the more it absorbs.'
              : answers.name + ', noted — that helps us set your typical session count.');
          stage = 'shaveFreq';
          push('guide', '¿Cada cuánto te rasuras hoy?', 'How often do you shave today?');
          renderTranscript(); renderPrompt(); scrollToBottom();
        });
        return;
      }

      if (stage === 'shaveFreq') {
        optionStep([
          { v: 'diario', es: 'Cada día', en: 'Every day', perWeek: 7 },
          { v: 'dias', es: 'Cada 2–3 días', en: 'Every 2–3 days', perWeek: 3 },
          { v: 'semanal', es: '1–2 veces por semana', en: '1–2 times a week', perWeek: 1.5 },
          { v: 'rara', es: 'Rara vez', en: 'Rarely', perWeek: 0.5 }
        ], 'shaveFreq', function (o) {
          answers.shaveFreq = o.v;
          answers.perWeek = o.perWeek;
          push('user', o.es, o.en);
          push('guide',
            answers.name + ', ya tengo todo lo que necesito. Mira bien esto...',
            answers.name + ', I have everything I need. Take a good look at this...');
          stage = 'cuenta';
          renderTranscript(); renderPrompt(); scrollToBottom();
        });
        return;
      }

      if (stage === 'cuenta') {
        var statement = document.createElement('div');
        statement.className = 'abbq-statement';
        statement.innerHTML = t(
          answers.name + ', el problema nunca fue tu vello.<br>Es <em>la cuchilla</em> — que no termina jamás.',
          answers.name + ', the problem was never your hair.<br>It\'s <em>the razor</em> — that never ends.');
        promptZone.appendChild(statement);

        var card = document.createElement('div');
        card.className = 'abbq-cuenta-card';
        card.innerHTML =
          '<div class="abbq-cuenta-kicker">' +
            '<span>' + t('Tu cuenta · la cuchilla para siempre', 'Your tally · the forever razor') + '</span>' +
            '<span class="abbq-years">' + t('en los próximos', 'over the next') + '<b data-years>' + horizonYears + ' ' + t('años','years') + '</b></span>' +
          '</div>' +
          '<div class="abbq-cuenta-row" style="border-top:none;margin-top:8px">' +
            '<span class="abbq-cuenta-label">' + t('Horas de tu vida, cuchilla en mano, una y otra vez.', 'Hours of your life, razor in hand, over and over.') + '</span>' +
            '<span class="abbq-cuenta-value" data-hours>0 h</span>' +
          '</div>' +
          '<div class="abbq-cuenta-row">' +
            '<span class="abbq-cuenta-label">' + t('Más, en cuchillas y cremas.', 'Plus, in razors and creams.') + '</span>' +
            '<span class="abbq-cuenta-value" data-cost>$0</span>' +
          '</div>' +
          '<div class="abbq-cuenta-slider-row">' +
            '<div class="abbq-cuenta-slider-labels"><span>' + t('Horizonte', 'Horizon') + '</span><span>' + t('arrástralo', 'drag it') + '</span></div>' +
            '<input type="range" data-horizon min="1" max="50" value="' + horizonYears + '" />' +
          '</div>';
        promptZone.appendChild(card);

        function computeAndRender() {
          var zonesArr = zonesData.filter(function (z) { return answers.zones.has(z.id); });
          var minutesPerSession = 8 * Math.max(1, zonesArr.length);
          var costPerSession = 2 * Math.max(1, zonesArr.length);
          var perWeek = answers.perWeek || 1.5;
          var hours = perWeek * 52 * (minutesPerSession / 60) * horizonYears;
          var cost = perWeek * 52 * costPerSession * horizonYears;
          card.querySelector('[data-hours]').textContent = fmt(hours) + ' h';
          card.querySelector('[data-cost]').textContent = '$' + fmt(cost);
          card.querySelector('[data-years]').textContent = horizonYears + ' ' + t('años', 'years');
        }
        computeAndRender();
        card.querySelector('[data-horizon]').addEventListener('input', function (e) {
          horizonYears = Number(e.target.value);
          computeAndRender();
        });

        var note = document.createElement('p');
        note.className = 'abbq-cuenta-note';
        note.textContent = t(
          'El láser es una membresía de 8 a 9 meses, desde $39/mes por zona — y al terminar, 1 retoque al año GRATIS. Lo haces una etapa y se acaba; la cuchilla, nunca.',
          'Laser is an 8–9 month membership, from $39/mo per zone — and when you finish, 1 FREE yearly touch-up. You do it once and it\'s done; the razor never is.');
        promptZone.appendChild(note);

        var actions = document.createElement('div');
        actions.className = 'abbq-prompt-actions';
        var next = document.createElement('button');
        next.className = 'abbq-btn abbq-btn-primary';
        next.textContent = t('Mi plan sin vello →', 'My hair-free plan →');
        next.addEventListener('click', function () {
          stage = 'hormonal';
          push('guide', '¿Tienes SOP o vello hormonal?', 'Do you have PCOS or hormonal hair?');
          renderTranscript(); renderPrompt(); scrollToBottom();
        });
        actions.appendChild(next);
        promptZone.appendChild(actions);
        return;
      }

      if (stage === 'hormonal') {
        optionStep([
          { v: 'si', es: 'Sí', en: 'Yes' },
          { v: 'no', es: 'No', en: 'No' },
          { v: 'no-se', es: 'No estoy segura', en: 'Not sure' }
        ], 'hormonal', function (o) {
          answers.hormonal = o.v;
          push('user', o.es, o.en);
          push('guide',
            o.v === 'si'
              ? answers.name + ', lo vemos cada semana — y se trata con respeto, nunca con pena. Tu plan se arma distinto y puede incluir mantenimiento.'
              : answers.name + ', anotado.',
            o.v === 'si'
              ? answers.name + ', we see it every week — and treat it with respect, never shame. Your plan is built differently and may include maintenance.'
              : answers.name + ', noted.');
          stage = 'urgency';
          push('guide', '¿Hay algo especial en el horizonte — playa, boda?', 'Anything special coming up — beach, wedding?');
          renderTranscript(); renderPrompt(); scrollToBottom();
        });
        return;
      }

      if (stage === 'urgency') {
        optionStep([
          { v: 'playa', es: 'Playa o viaje pronto', en: 'Beach trip soon' },
          { v: 'boda', es: 'Boda o evento especial', en: 'Wedding or event' },
          { v: 'ninguno', es: 'Nada en particular', en: 'Nothing in particular' }
        ], 'urgency', function (o) {
          answers.urgency = o.v;
          push('user', o.es, o.en);
          push('guide',
            answers.name + ', último paso — ¿a dónde te envío tu plan?',
            answers.name + ', last step — where do I send your plan?');
          stage = 'phone';
          renderTranscript(); renderPrompt(); scrollToBottom();
        });
        return;
      }

      if (stage === 'phone') {
        textStep('tel', 'Tu teléfono', 'Your phone', 'Continuar', 'Continue', function (val) {
          if (!val) return;
          answers.phone = val;
          push('user', val, val);
          stage = 'email';
          renderTranscript(); renderPrompt(); scrollToBottom();
        });
        return;
      }

      if (stage === 'email') {
        var wrap = document.createElement('div');
        wrap.className = 'abbq-text-prompt';
        var input = document.createElement('input');
        input.className = 'abbq-input'; input.type = 'email';
        input.placeholder = t('Tu email', 'Your email');
        var btn = document.createElement('button');
        btn.className = 'abbq-btn abbq-btn-primary';
        btn.textContent = t('Ver mi veredicto', 'See my verdict');

        var consentRow = document.createElement('label');
        consentRow.className = 'abbq-consent-row';
        var check = document.createElement('input');
        check.type = 'checkbox';
        check.className = 'abbq-consent-check';
        var consentText = document.createElement('span');
        consentText.innerHTML = t(
          'Autorizo a Agave Beauty Bar a contactarme por WhatsApp y email sobre mi plan y evaluación. Puedo cancelar cuando quiera.',
          'I authorize Agave Beauty Bar to contact me by WhatsApp and email about my plan and evaluation. I can opt out anytime.');
        consentRow.appendChild(check); consentRow.appendChild(consentText);

        function syncBtn() {
          var ok = input.value.trim() && check.checked;
          btn.disabled = !ok;
          btn.style.opacity = ok ? '1' : '0.45';
          btn.style.pointerEvents = ok ? 'auto' : 'none';
        }
        btn.addEventListener('click', function () {
          var val = input.value.trim();
          if (!val || !check.checked) return;
          answers.email = val;
          answers.consent = true;
          push('user', val, val);
          submitLead();
          stage = 'done';
          renderTranscript(); renderPrompt(); scrollToBottom();
        });
        input.addEventListener('keydown', function (e) { if (e.key === 'Enter') btn.click(); });
        input.addEventListener('input', syncBtn);
        check.addEventListener('change', syncBtn);
        wrap.appendChild(input); wrap.appendChild(btn);
        promptZone.appendChild(wrap);
        promptZone.appendChild(consentRow);
        syncBtn();
        return;
      }

      if (stage === 'done') {
        var zonesArr = zonesData.filter(function (z) { return answers.zones.has(z.id); });
        var total = zonesArr.reduce(function (s, z) { return s + z.price; }, 0);
        var block = document.createElement('div');
        block.className = 'abbq-result-block';
        block.innerHTML =
          '<p class="abbq-result-price">$' + total + '<span style="font-size:16px">/' + t('mes','mo') + '</span></p>' +
          '<p class="abbq-result-first">' + t('Incluye 1 retoque al año GRATIS', 'Includes 1 FREE yearly touch-up') + '</p>' +
          '<p class="abbq-result-zones">' + zonesArr.map(function (z) { return t(z.es, z.en); }).join(', ') + '</p>' +
          '<div class="abbq-result-actions">' +
            '<button type="button" data-pay class="abbq-btn abbq-btn-primary abbq-btn-block">' + t('Activar mi membresía — $' + total + '/mes','Activate my membership — $' + total + '/mo') + ' →</button>' +
            '<p data-pay-error style="display:none;font-size:12.5px;color:var(--abbq-accent-dark);margin:0"></p>' +
            '<a href="' + BOOKING + '" class="abbq-btn abbq-btn-ghost abbq-btn-block" target="_blank" rel="noopener noreferrer">' + t('Prefiero agendar mi evaluación primero','I prefer to book my evaluation first') + '</a>' +
          '</div>';
        promptZone.appendChild(block);

        var payBtn = block.querySelector('[data-pay]');
        var payError = block.querySelector('[data-pay-error]');
        payBtn.addEventListener('click', async function () {
          var original = payBtn.textContent;
          payBtn.disabled = true;
          payBtn.style.opacity = '0.6';
          payBtn.textContent = t('Abriendo pago seguro…', 'Opening secure checkout…');
          payError.style.display = 'none';
          try {
            var res = await fetch(CHECKOUT_URL, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                zones: zonesArr.map(function (z) { return z.id; }),
                name: answers.name || '',
                phone: answers.phone || '',
                email: answers.email || '',
                skinTone: answers.skinTone || '',
                hairColor: answers.hairColor || '',
                hairThickness: answers.hairThickness || '',
                hormonal: answers.hormonal || '',
                urgency: answers.urgency || ''
              })
            });
            var data = await res.json();
            if (data.url) { window.location.href = data.url; return; }
            throw new Error(data.error || 'checkout');
          } catch (err) {
            payError.textContent = t('No pudimos abrir el pago. Escríbenos por WhatsApp y lo activamos contigo.', 'We could not open checkout. Message us on WhatsApp and we will set it up with you.');
            payError.style.display = 'block';
            payBtn.disabled = false;
            payBtn.style.opacity = '1';
            payBtn.textContent = original;
          }
        });
        return;
      }
    }

    function submitLead() {
      if (!ENDPOINT) return;
      var zonesArr = zonesData.filter(function (z) { return answers.zones.has(z.id); });
      var total = zonesArr.reduce(function (s, z) { return s + z.price; }, 0);
      var params = new URLSearchParams();
      params.append('name', answers.name || '');
      params.append('phone', answers.phone || '');
      params.append('email', answers.email || '');
      params.append('zones', zonesArr.map(function (z) { return z.es; }).join(', '));
      params.append('skinTone', answers.skinTone || '');
      params.append('hairColor', answers.hairColor || '');
      params.append('hairThickness', answers.hairThickness || '');
      params.append('shaveFreq', answers.shaveFreq || '');
      params.append('hormonal', answers.hormonal || '');
      params.append('urgency', answers.urgency || '');
      params.append('monthlyPrice', '$' + total + '/mo');
      params.append('consent', answers.consent ? 'YES — authorized WhatsApp + email follow-up' : 'no');
      params.append('consentTimestamp', new Date().toISOString());
      fetch(ENDPOINT, { method: 'POST', mode: 'no-cors', body: params }).catch(function () {});
    }

    root.querySelectorAll('[data-lang-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        lang = b.dataset.langBtn;
        root.setAttribute('data-lang', lang);
        root.querySelectorAll('[data-lang-btn]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        renderTranscript(); renderPrompt();
      });
    });

    push('guide', '¿Cómo te llamas?', 'What\'s your name?');
    renderTranscript();
    renderPrompt();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
